import { d as debounce_1 } from "common/chunk_debounce";

class ResizeObserverAdapter {
  observer = null;

  constructor(setValue) {
    this.setValue = setValue;
  }

  connect() {}

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  update(config) {
    if (!this.observer) {
      // @ts-ignore
      this.observer = new ResizeObserver(
        debounce_1((entries) => {
          this.setValue(entries[0]);
        }, 250)
      );
      this.observer.observe(config.template.host, config.options);
    }
  }
}

export { ResizeObserverAdapter };
